import React, { useState, useEffect } from "react";
// import AudioPlayer from "material-ui-audio-player";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
import { Input as BaseInput, InputProps, inputClasses } from "@mui/base/Input";
import { makeStyles } from "@material-ui/core";
import CryptoJS from "crypto-js";

import {
  Pagination,
  Stack,
  TableRow,
  TablePagination,
  TableHead,
  TableContainer,
  TableBody,
  Table,
  Paper,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Button,
  DialogActions,
  Slide,
} from "@mui/material";
import { Eye, MagnifyingGlass } from "@phosphor-icons/react";
import { BaseUrl } from "../../Container/BaseUrl/BaseUrl";
import axios from "axios";
import moment from "moment";
import { AiOutlineFileExcel } from "react-icons/ai";

const Input = React.forwardRef(function CustomInput(
  props: InputProps,
  ref: React.ForwardedRef<HTMLDivElement>
) {
  const { slots, ...other } = props;
  return (
    <BaseInput
      slots={{
        root: InputRoot,
        input: InputElement,
        ...slots,
      }}
      {...other}
      ref={ref}
    />
  );
});

const blue = {
  100: "#DAECFF",
  200: "#80BFFF",
  400: "#3399FF",
  500: "#007FFF",
  600: "#0072E5",
  700: "#0059B2",
};

const grey = {
  50: "#F3F6F9",
  100: "#E5EAF2",
  200: "#DAE2ED",
  300: "#C7D0DD",
  400: "#B0B8C4",
  500: "#9DA8B7",
  600: "#6B7A90",
  700: "#434D5B",
  800: "#303740",
  900: "#1C2025",
};

const InputRoot = styled("div")(
  ({ theme }) => `
  font-family: 'IBM Plex Sans', sans-serif;
  font-weight: 400;
  border-radius: 8px;
  color: ${theme.palette.mode === "dark" ? grey[300] : grey[500]};
  background: ${theme.palette.mode === "dark" ? grey[900] : "#fff"};
  border: 1px solid ${theme.palette.mode === "dark" ? grey[700] : grey[200]};
  box-shadow: 0px 2px 4px ${theme.palette.mode === "dark" ? "rgba(0,0,0, 0.5)" : "rgba(0,0,0, 0.05)"
    };
  display: flex;
  align-items: center;
  justify-content: center;


  // firefox
  &:focus-visible {
    outline: 0;
  }
`
);

const InputElement = styled("input")(
  ({ theme }) => `
  font-size: 0.875rem;
  font-family: inherit;
  font-weight: 400;
  line-height: 1.5;
  flex-grow: 1;
  color: ${theme.palette.mode === "dark" ? grey[300] : grey[900]};
  background: inherit;
  border: none;
  border-radius: inherit;
  padding: 8px 12px;
  outline: 0;
  width: 450px;
 
  &:focus-visible {
    outline:none;
    outline-offset: none;
  }
  
`
);

const InputAdornment = styled("div")`
  margin: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#e9e9e9",
    color: theme.palette.common.black,
    padding: "10px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 11,
  },
}));

const StyledTableCell2 = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.root}`]: {
    backgroundColor: "#FFFF",
    color: theme.palette.common.black,
    padding: "7px 10px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 13,
  },
}));

const useStyles = makeStyles((theme: any) => {
  return {
    root: {
      [theme.breakpoints.down("sm")]: {
        width: "100%",
      },
    },
    volumeSlider: {
      color: "black",
    },
    progressTime: {
      color: "rgba(0, 0, 0, 0.54)",
    },
    mainSlider: {
      color: "#3f51b5",
      "& .MuiSlider-rail": {
        color: "#7986cb",
      },
      "& .MuiSlider-track": {
        color: "#3f51b5",
      },
      "& .MuiSlider-thumb": {
        color: "#303f9f",
      },
    },
  };
});

const SessionHistory = (props) => {
  const logedinAgent = JSON.parse(localStorage.getItem("tokenAgent"));
  const [sessionVal, setsessionVal] = useState([]);
  const [SummeryOpenDialog, setSummeryOpenDialog] = useState(false);
  const [ChatHistoryOpenDialog, setChatHistoryOpenDialog] = useState(false);
  const [ChatHistory, setChatHistory] = useState([]);
  const [SummeryData, setSummeryData] = useState();
  const [SummeryData2, setSummeryData2] = useState();

  const [searchMessage, setsearchMessage] = useState("");
  var someDate = new Date();
  var date = someDate.setDate(someDate.getDate());
  var defaultValue = new Date(date).toISOString().split("T")[0];

  const getSessionsDetails = async (value) => {
    await axios
      .post(
        BaseUrl + "/message/getSessions/",
        {
          email: props.selectedUser.email,
          phonenumber: props.selectedUser.phonenumber,
          date: value,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.success) {
          setsessionVal(res.data.data);
        } else {
          setsessionVal([]);
        }
      });
  };

  const handleShowDetails = async (session_id) => {
    await axios
      .post(
        BaseUrl + "/message/getSummery/",
        { sessionId: session_id },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.success) {
          setSummeryData(res.data.data[0]);
          setSummeryData2(res.data.data[1]);
          setSummeryOpenDialog(true);
        } else {
          setSummeryData();
          setSummeryData2();
          setSummeryOpenDialog(true);
        }
      })
      .catch((err) => { });
  };

  const showChatHistoryDialogBox = async (value) => {
    await axios
      .post(
        BaseUrl + "/message/chatHistories/",
        { sessionId: value },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          setChatHistory(res.data.data);
          setChatHistoryOpenDialog(true);
        } else {
          setChatHistory([]);
          setChatHistoryOpenDialog(true);
        }
      })
      .catch((err) => {
        console.log("err", err);
        setChatHistory([]);
        setChatHistoryOpenDialog(true);
      });
  };

  useEffect(() => {
    getSessionsDetails(defaultValue);
  }, [props.selectedUser]);

  const SummeryCloseDialogBox = () => {
    setSummeryOpenDialog(false);
  };
  const ChatHistoryCloseDialog = () => {
    setChatHistoryOpenDialog(false);
    setSummeryOpenDialog(true);
  };

  return (
    <>
      <div
        className="tab-pane fade show active"
        id="pills-profile"
        role="tabpanel"
        aria-labelledby="pills-profile-tab"
      >
        <Paper
          sx={{
            width: "100%",
            overflow: "hidden",
          }}
        >
          <TableContainer sx={{ maxHeight: 300 }}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  <StyledTableCell>Channel</StyledTableCell>
                  <StyledTableCell>Agent</StyledTableCell>
                  <StyledTableCell>Language</StyledTableCell>
                  <StyledTableCell>Date</StyledTableCell>
                  <StyledTableCell>SkillSet</StyledTableCell>
                  <StyledTableCell>Reason</StyledTableCell>
                  <StyledTableCell>Action</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {sessionVal.length > 0
                  ? sessionVal.map((item) => (
                    <TableRow hover role="checkbox" tabIndex={-1}>
                      <StyledTableCell2 align="center">
                        {item.channel == "webchat" ? (
                          <div
                            className="box d-flex align-items-center justify-content-center sms-bg"
                            style={{ boxShadow: "2px 3px 10px gray" }}
                          >
                            <i className="fa-brands fa-rocketchat"></i>
                          </div>
                        ) : item.channel == "from_whatsapp" ? (
                          <div
                            className="box d-flex align-items-center justify-content-center what-bg"
                            style={{ boxShadow: "2px 3px 10px gray" }}
                          >
                            <i className="fa-brands fa-whatsapp"></i>
                          </div>
                        ) : item.channel == "from_facebook" ? (
                          <div
                            className=" box d-flex align-items-center justify-content-center fb-bg"
                            style={{ boxShadow: "2px 3px 10px gray" }}
                          >
                            <i className="fa-brands fa-facebook-f"></i>
                          </div>
                        ) : item.channel == "from_twitter" ? (
                          <div
                            className="  box d-flex align-items-center justify-content-center twit-bg"
                            style={{ boxShadow: "2px 3px 10px gray" }}
                          >
                            <i className="fa-brands fa-twitter"></i>
                          </div>
                        ) : item.channel == "from_teams" ? (
                          <div
                            className=" box d-flex align-items-center justify-content-center teams-bg"
                            style={{ boxShadow: "2px 3px 10px gray" }}
                          >
                            <i className="fa-brands fa-teams"></i>
                            <SiMicrosoftteams
                              className="btn_hover"
                              size={20}
                              color="white"
                            />
                          </div>
                        ) : item.channel == "videochat" ? (
                          <div
                            className="  box d-flex align-items-center justify-content-center twit-bg"
                            style={{ boxShadow: "2px 3px 10px gray" }}
                          >
                            <i className="fa-solid fa-video"></i>
                          </div>
                        ) : item.channel == "voice" ? (
                          <div
                            className="  box d-flex align-items-center justify-content-center twit-bg"
                            style={{ boxShadow: "2px 3px 10px gray" }}
                          >
                            <i className="fa-solid fa-phone"></i>
                          </div>
                        ) : item.channel == "from_purple" ? (
                          <div
                            className="  box d-flex align-items-center justify-content-center twit-bg"
                            style={{ boxShadow: "2px 3px 10px gray" }}
                          >
                            <i className="fa-solid fa-robot"></i>
                          </div>
                        ) : (
                          <div
                            className="  box d-flex  align-items-center justify-content-center call-bg"
                            style={{ boxShadow: "2px 3px 10px gray" }}
                          >
                            <i className="fa-solid fa-envelope"></i>
                          </div>
                        )}
                      </StyledTableCell2>
                      <StyledTableCell2 style={{ width: "max-content" }}>
                        {item.agent?.username}
                      </StyledTableCell2>
                      <StyledTableCell2>{item.language}</StyledTableCell2>
                      <StyledTableCell2>
                        {moment(item.chat_started_at).format("L LT")}
                      </StyledTableCell2>
                      <StyledTableCell2>{item.skillset}</StyledTableCell2>
                      <StyledTableCell2>{item.reason}</StyledTableCell2>
                      <StyledTableCell2>
                        {item.channel == "voice" ? null : (
                          <IconButton
                            id="view_summery"
                            onClick={() => {
                              setSummeryOpenDialog(true);
                              handleShowDetails(item.chat_session_id);
                            }}
                          >
                            <Eye size={18} cursor={"pointer"} />
                          </IconButton>
                        )}
                      </StyledTableCell2>
                    </TableRow>
                  ))
                  : ""}
              </TableBody>
            </Table>
          </TableContainer>
          {/* <Stack direction={"row"} justifyContent={"end"}>
          <Pagination
            count={10}
            variant="outlined"
            shape="rounded"
            color="primary"
            size="small"
          />
        </Stack> */}
        </Paper>
      </div>

      <Dialog
        open={SummeryOpenDialog}
        TransitionComponent={Transition}
        keepMounted
        onClose={SummeryCloseDialogBox}
        aria-describedby="alert-dialog-slide-description"
        sx={{
          "& .MuiPaper-root": {
            borderRadius: 5,
            padding: 1,
            top: -50,
            maxWidth: "900px",
          },

          backgroundColor: "rgb(0 0 0 / 65%)",
        }}
      >
        <DialogTitle
          variant="subtitle2"
          sx={{ fontSize: "16px", fontWeight: 600 }}
        >
          SUMMERY
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <TableContainer sx={{ maxHeight: 300 }}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell>Chat Arrival At</StyledTableCell>
                    <StyledTableCell>Chat Started At</StyledTableCell>
                    <StyledTableCell>Comments</StyledTableCell>
                    <StyledTableCell>Chat End At</StyledTableCell>
                    <StyledTableCell>Channel</StyledTableCell>
                    <StyledTableCell>SkillSet</StyledTableCell>
                    <StyledTableCell>Agent</StyledTableCell>
                    <StyledTableCell>View</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow hover role="checkbox" tabIndex={-1}>
                    <StyledTableCell2>
                      {SummeryData
                        ? moment(SummeryData.arrival_at).format("L LT")
                        : ""}
                    </StyledTableCell2>
                    <StyledTableCell2>
                      {SummeryData
                        ? moment(SummeryData.chat_started_at).format("L LT")
                        : ""}
                    </StyledTableCell2>
                    <StyledTableCell2>
                      {SummeryData ? SummeryData.comments : "null"}
                    </StyledTableCell2>
                    <StyledTableCell2>
                      {SummeryData
                        ? moment(SummeryData.chat_ended_at).format("L LT")
                        : ""}
                    </StyledTableCell2>
                    <StyledTableCell2>
                      {SummeryData ? SummeryData.channel : ""}
                    </StyledTableCell2>
                    <StyledTableCell2>
                      {SummeryData ? SummeryData.skillset : ""}
                    </StyledTableCell2>
                    <StyledTableCell2>
                      {SummeryData
                        ? `${SummeryData.agent ? SummeryData.agent.username : ""
                        } ${SummeryData2 ? SummeryData2.confUser : ""}`
                        : ""}
                    </StyledTableCell2>
                    <StyledTableCell2>
                      <IconButton
                        id="view_summery"
                        onClick={() => {
                          showChatHistoryDialogBox(
                            SummeryData ? SummeryData.chat_session_id : ""
                          );
                        }}
                      >
                        <Eye size={18} cursor={"pointer"} />
                      </IconButton>
                    </StyledTableCell2>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </DialogContentText>
        </DialogContent>
      </Dialog>

      <Dialog
        open={ChatHistoryOpenDialog}
        TransitionComponent={Transition}
        keepMounted
        onClose={ChatHistoryCloseDialog}
        aria-describedby="alert-dialog-slide-description"
        sx={{
          "& .MuiPaper-root": {
            borderRadius: 5,
            padding: 1,
            maxWidth: "900px",
          },

          backgroundColor: "rgb(0 0 0 / 65%)",
        }}
      >
        <DialogTitle
          variant="subtitle2"
          sx={{ fontSize: "16px", fontWeight: 600 }}
        >
          CHAT HISTORY
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <Stack justifyContent={"center"} alignItems={"center"}>
              <Input
                aria-label="Demo input"
                type="url"
                value={searchMessage}
                onChange={(e) => setsearchMessage(e.target.value)}
                placeholder="Find Message...!"
                startAdornment={
                  <InputAdornment>
                    <MagnifyingGlass size={22} weight="fill" />
                  </InputAdornment>
                }
              />

              <div
                className="chat-box-body"
                style={{
                  backgroundColor: "transparent !important",
                  marginTop: "10px",
                }}
              >
                <div className="chat-logs" style={{ height: "60vh", width: '30vw' }}>
                  {ChatHistory &&
                    ChatHistory.filter((message) =>
                      CryptoJS.AES.decrypt(message.message, "your-secret-key").toString(CryptoJS.enc.Utf8)
                        .toLowerCase()
                        .includes(searchMessage.toLowerCase())
                    ).map((message) => {
                      if (message.msg_sent_type === "NOTIFICATIONS") {
                        if (CryptoJS.AES.decrypt(message.message, "your-secret-key").toString(CryptoJS.enc.Utf8) === "Customer Ended the Chat") {
                          return (
                            <div
                              className="times"
                              style={{ background: "#d93d32" }}
                            >
                              {CryptoJS.AES.decrypt(message.message, "your-secret-key").toString(CryptoJS.enc.Utf8)}
                            </div>
                          );
                        } else {
                          return <div className="times">{CryptoJS.AES.decrypt(message.message, "your-secret-key").toString(CryptoJS.enc.Utf8)}</div>;
                        }
                      } else if (message.senderName == logedinAgent.username) {
                        return (
                          <div className="chat-r">
                            <div className="user-chat-main d-flex justify-content-end flex-column align-items-end">
                              {message.msg_sent_type === "TEXT" ||
                                message.msg_sent_type == "text" ? (
                                <div className="user-chats text-break">
                                  {CryptoJS.AES.decrypt(message.message, "your-secret-key").toString(CryptoJS.enc.Utf8).includes("http://") ||
                                    CryptoJS.AES.decrypt(message.message, "your-secret-key").toString(CryptoJS.enc.Utf8).includes("www.") ||
                                    CryptoJS.AES.decrypt(message.message, "your-secret-key").toString(CryptoJS.enc.Utf8).includes("https://")
                                    ? CryptoJS.AES.decrypt(message.message, "your-secret-key").toString(CryptoJS.enc.Utf8)
                                      .split(" ")
                                      .map((word, index) => {
                                        if (
                                          word.includes("http://") ||
                                          word.includes("https://") ||
                                          word.includes("www.")
                                        ) {
                                          return (
                                            <a
                                              href={word}
                                              key={index}
                                              style={{
                                                color: "white",
                                                borderBottom:
                                                  "1px solid grey",
                                                textDecoration: "underline",
                                              }}
                                              target="_blank"
                                            >
                                              {word}
                                            </a>
                                          );
                                        } else {
                                          return word + " ";
                                        }
                                      })
                                    : CryptoJS.AES.decrypt(message.message, "your-secret-key").toString(CryptoJS.enc.Utf8)}
                                </div>
                              ) : null}

                              {message.msg_sent_type === "APPLICATION" ? (
                                <div className="user-chats-file algin-text">
                                  <a
                                    href={CryptoJS.AES.decrypt(message.message, "your-secret-key").toString(CryptoJS.enc.Utf8)}
                                    target="_blank"
                                    className="text-white"
                                  >
                                    <AiOutlineFileExcel
                                      size={20}
                                      className="excel-icon"
                                    />{" "}
                                    {message.file_name}
                                  </a>
                                </div>
                              ) : null}

                              {message.msg_sent_type === "IMAGE" ? (
                                <div className="card p-2">
                                  <a href={CryptoJS.AES.decrypt(message.message, "your-secret-key").toString(CryptoJS.enc.Utf8)} target="_blank">
                                    <img
                                      src={CryptoJS.AES.decrypt(message.message, "your-secret-key").toString(CryptoJS.enc.Utf8)}
                                      height="130px"
                                      width={150}
                                      alt="image not available"
                                    />
                                  </a>
                                </div>
                              ) : null}

                              {message.msg_sent_type === "VIDEO" ? (
                                <div
                                  className="card p-2"
                                  style={{ borderRadius: "10px 10px 0 10px" }}
                                >
                                  <a href={CryptoJS.AES.decrypt(message.message, "your-secret-key").toString(CryptoJS.enc.Utf8)} target="_blank">
                                    <video width="150" controls>
                                      <source
                                        src={CryptoJS.AES.decrypt(message.message, "your-secret-key").toString(CryptoJS.enc.Utf8)}
                                        type="video/mp4"
                                      />
                                    </video>
                                  </a>
                                </div>
                              ) : null}

                              {/* {message.msg_sent_type === "AUDIO" ? (
                                <div className="user-chats-audio">
                                  <AudioPlayer
                                    src={CryptoJS.AES.decrypt(message.message, "your-secret-key").toString(CryptoJS.enc.Utf8)}
                                    useStyles={useStyles}
                                  />
                                </div>
                              ) : null} */}
                            </div>
                            <div className="chat-time-r">
                              {moment(message.time).format("h:mm A")} -
                              <div
                                className="mx-1"
                                style={{ fontSize: "10px" }}
                              >
                                {message.senderName}
                              </div>
                            </div>
                          </div>
                        );
                      } else if (message.senderName !== logedinAgent.username) {
                        return (
                          <div className="chat-l">
                            <div className="bot-chat-main d-flex justify-content-start">
                              <div className="d-flex justify-content-start flex-column align-items-start w-100">
                                {message.msg_sent_type === "TEXT" ||
                                  message.msg_sent_type === "text" ? (
                                  <div className="bot-chats text-break">
                                    {CryptoJS.AES.decrypt(message.message, "your-secret-key").toString(CryptoJS.enc.Utf8).includes("http://") ||
                                      CryptoJS.AES.decrypt(message.message, "your-secret-key").toString(CryptoJS.enc.Utf8).includes("www.") ||
                                      CryptoJS.AES.decrypt(message.message, "your-secret-key").toString(CryptoJS.enc.Utf8).includes("https://")
                                      ? CryptoJS.AES.decrypt(message.message, "your-secret-key").toString(CryptoJS.enc.Utf8)
                                        .split(" ")
                                        .map((word, index) => {
                                          if (
                                            word.includes("http://") ||
                                            word.includes("https://") ||
                                            word.includes("www.")
                                          ) {
                                            return (
                                              <a
                                                href={word}
                                                key={index}
                                                style={{
                                                  color: "white",
                                                  borderBottom:
                                                    "1px solid #FFFF",
                                                  textDecoration: "underline",
                                                }}
                                                target="_blank"
                                              >
                                                {word}
                                              </a>
                                            );
                                          } else {
                                            return word + " ";
                                          }
                                        })
                                      : CryptoJS.AES.decrypt(message.message, "your-secret-key").toString(CryptoJS.enc.Utf8)}
                                  </div>
                                ) : null}

                                {message.msg_sent_type === "APPLICATION" ? (
                                  <div className="user-chats-file text-break">
                                    <a
                                      href={CryptoJS.AES.decrypt(message.message, "your-secret-key").toString(CryptoJS.enc.Utf8)}
                                      target="_blank"
                                      className="text-white"
                                    >
                                      <AiOutlineFileExcel
                                        size={20}
                                        className="excel-icon"
                                      />{" "}
                                      {message.file_name}
                                    </a>
                                  </div>
                                ) : null}

                                {message.msg_sent_type === "IMAGE" ? (
                                  <div
                                    className="card p-2"
                                    style={{ height: "150px" }}
                                  >
                                    <a href={CryptoJS.AES.decrypt(message.message, "your-secret-key").toString(CryptoJS.enc.Utf8)} target="_blank">
                                      <img
                                        src={CryptoJS.AES.decrypt(message.message, "your-secret-key").toString(CryptoJS.enc.Utf8)}
                                        height="130px"
                                        width={150}
                                        alt="image not available"
                                      />
                                    </a>
                                  </div>
                                ) : null}

                                {message.msg_sent_type === "VIDEO" ? (
                                  <div
                                    className="card p-2"
                                    style={{
                                      borderRadius: "10px 10px 10px 0px",
                                    }}
                                  >
                                    <a href={CryptoJS.AES.decrypt(message.message, "your-secret-key").toString(CryptoJS.enc.Utf8)} target="_blank">
                                      <video width="150" controls>
                                        <source
                                          src={CryptoJS.AES.decrypt(message.message, "your-secret-key").toString(CryptoJS.enc.Utf8)}
                                          type="video/mp4"
                                        />
                                      </video>
                                    </a>
                                  </div>
                                ) : null}

                                {/* {message.msg_sent_type === "AUDIO" ? (
                                  <div className="user-chats-audio">
                                    <AudioPlayer
                                      src={CryptoJS.AES.decrypt(message.message, "your-secret-key").toString(CryptoJS.enc.Utf8)}
                                      useStyles={useStyles}
                                    />
                                  </div>
                                ) : null} */}
                              </div>
                            </div>

                            <div className="chat-time-l">
                              {moment(message.time).format("h:mm A")} -
                              <div
                                className="mx-1"
                                style={{ fontSize: "10px" }}
                              >
                                {message.senderName}
                              </div>
                            </div>
                          </div>
                        );
                      }
                    })}
                </div>
              </div>
            </Stack>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default SessionHistory;
